import {
    TRACK_PAGE_VIEW_START,
    TRACK_EVENT_START,
    TRACK_SUCCESS,
    TRACK_ERROR,
} from './types';

export const trackPageView = eventData => ({
    type: TRACK_PAGE_VIEW_START,
    payload: eventData,
});

export const trackEvent = eventData => ({
    type: TRACK_EVENT_START,
    payload: eventData,
});

export const trackSuccess = () => ({
    type: TRACK_SUCCESS,
});

export const trackError = error => ({
    type: TRACK_ERROR,
    payload: error,
});
